import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import SBInvoiceForm from '../components/SBInvoiceForm';
import { Stack } from '@mui/material';
import { useCreateInvoiceHandler } from '../../Invoices/dataHandlers/createInvoiceHandler';

export default function CreateSBInvoicePage() {
  useDocumentTitle('Invoice Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state?.document;

  const onInvoiceCreated = (payload) => {
    if (payload.status === 'draft') {
      navigate('/self-billed-drafts?tab=self-billed-invoices');
    } else {
      navigate('/self-billed-documents?tab=self-billed-invoices');
    }
  };

  const { onSubmit, error } = useCreateInvoiceHandler({ onSuccess: onInvoiceCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };

    await onSubmit(payload, data.status);
  };
  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = async () => {
    navigate(location.state?.from || '/self-billed-documents?tab=self-billed-invoices');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SBInvoiceForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
      />
    </Stack>
  );
}
